import React from "react"
import { MobileButton } from "@/components/shared/button/button"
import ModalComponent from "@/components/shared/modal/modal"
import { Col, Container, Row, Accordion } from "react-bootstrap"


const SearchHistoryButton = ({ price,  m2, netto = false,  sold = false, history = [] }) => (
  <ModalComponent>
    <MobileButton
      bg={sold ? '#eee' : 'black'}
      color={sold? 'black' : 'white'}
      border={"transparent"}
      arrow={false}
      smallArrow={false}
      disabled={sold}
      className={"price"}
    >

      <div>
        <span>
          {price ?
            price?.toLocaleString('PL', {style: 'currency', currency: 'PLN'}) :
            'Zapytaj o cenę'
          }
        </span>
        {m2 && (


            <small>{m2?.toLocaleString('PL', {style: 'currency', currency: 'PLN'})}/m<sup>2</sup></small>

        )}
        {netto && (
          <small style={{display: 'block', }}>
            (cena netto)
          </small>
        )}
      </div>
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
           viewBox="0 0 24 24" fill="none" stroke="currentColor"
           stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      >
        <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
        <path d="M3 3v5h5" />
        <path d="M12 7v5l4 2" />
      </svg>
    </MobileButton>
    <div>

      <Container style={{ paddingTop: "20px", paddingBottom: "20px" }}>
        <Row>
          <Col>
            <h4 style={{paddingBottom: '24px;'}}>Historia zmian ceny</h4>
            <hr/>
            <table style={{ width: "100%" }} className="table table-striped table-bordered">
              <thead>
              <tr>
                <th>Data zmiany</th>
                <th>Pow. użytkowa</th>
                <th>Cena za m²</th>
                <th>Cena całkowita</th>
              </tr>
              </thead>
              <tbody>
              {history.length && history.map((item, index) => (
                <tr key={index}>
                  <td>{item.date}</td>
                  <td>{item.size.toLocaleString('PL')}m<sup>2</sup></td>
                  <td>{item.m2.toLocaleString('PL', {style: 'currency', currency: 'PLN'}) }</td>
                  <td>{item.price.toLocaleString('PL', {style: 'currency', currency: 'PLN'}) }</td>
                </tr>
              ))}
              </tbody>
            </table>
          </Col>
        </Row>

      </Container>
    </div>
  </ModalComponent>
)

export default SearchHistoryButton
